import { render, staticRenderFns } from "./RobotSorryAlert.vue?vue&type=template&id=6f36f8df&"
import script from "./RobotSorryAlert.vue?vue&type=script&lang=js&"
export * from "./RobotSorryAlert.vue?vue&type=script&lang=js&"
import style0 from "./RobotSorryAlert.vue?vue&type=style&index=0&id=6f36f8df&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports